import { LOADING_SHOW, LOADING_HIDE } from "./loading.actions";

const loading = (state = { loading: false }, action) => {
  switch (action.type) {
    case LOADING_SHOW:
      return Object.assign({}, state, {
        loading: true,
      });
    case LOADING_HIDE:
      return Object.assign({}, state, {
        loading: false,
      });
    default:
      return state;
  }
};

export default loading;
